import "../../../../css/layout/sidebar.css";

const SidebarToolsList  = () => {
    

    return (
        <div className="sidebar-page-list">
            <div className='sidebar-page-list-div'>
                <a href={"/tools/mathplot"} style={{padding:0}}>
                    <h5 className='sidebar-page-list-div-link' >Graph Tool</h5>
                </a>
            </div>
        </div>
    );

}

export default SidebarToolsList;